import Vue from 'vue'
import * as apiService from 'API/delivery'
import { deepClone } from 'Utils/functions'

import zonesModule from 'PageShop/store/zones'
import pickupModule from 'PageShop/store/pickup'
import settingsModule from 'PageShop/store/settings'

const emptyStore = {
  id: '',
  regionId: '',
  address: ''
}

export default {
  namespaced: true,
  state: {
    currentStore: deepClone(emptyStore)
  },
  getters: {
    serializeStore: (state) => () => ({
      ...state.currentStore
    }),
    deserializeStore: () => (store) => ({
      ...deepClone(emptyStore),
      ...store
    })
  },
  actions: {
    async getStoreById({ commit, getters }, storeId) {
      try {
        const { data } = await apiService.getStoreById(storeId)
        commit('setStore', getters.deserializeStore(data))
      } catch (e) {
        console.error(e)
        throw e
      }
    }
  },
  mutations: {
    setStore(state, store) {
      Vue.set(state, 'currentStore', deepClone(store))
    }
  },
  modules: {
    zonesModule,
    pickupModule,
    settingsModule
  }
}
